export default {
  name: 'SimpleVideo',
  data() {
    return {
      isVideoCanPlay: false,
      isMuted: true
    };
  },
  props: {
    videoInfo: {
      type: Object
    }
  },
  computed: {
    isLowPower() {
      return WXGAME.Env.isiOS && (window.__lowPowerMode__ || window.__lowPower__);
    }
  },
  methods: {
    initPlay() {
      // 延迟 0.4S 的切换时间
      setTimeout(() => {
        this.video = this.$refs.simpleVideo;

        if (this.video) {
          // 非直播绑定canplay
          this.video.addEventListener('canplay', () => {
            if (!this.isVideoCanPlay) {
              this.isVideoCanPlay = true;
              this.video.play();
            }
          });

          // 播放上报
          this.video.addEventListener('play', (event) => {
            this.$emit('video-play');
          });

          // important
          this.video.load();
        }
      }, 400);
    },
    // 更改视频是否有声音
    toggleMuted() {
      this.isMuted = !this.isMuted;
    },
    // 暂停视频
    pauseVideo() {
      if (this.video) {
        this.video.pause();
      }
    },
    // 继续播放视频
    continuePlayVideo() {
      if (this.video) {
        this.video.play();
      }
    }
  },
  mounted() {
    if (!this.isLowPower) {
      this.initPlay();
    }
  }
};
